const angular = require('angular');
const app = angular.module('learn-services');

/**
 * The signed-in half of the company configuration (integration links, hub links, editor settings).
 * The API serves it only to a session, so the public /v3/config bootstrap carries it only when the
 * page loaded with a stored token; a sign-in inside the app merges it here before the first secure
 * route renders (see the route resolve in learn-app.js).
 */
app.factory('CompanyConfiguration', ['$http', '$q', '$rootScope', 'appConfiguration', 'Access', function($http, $q, $rootScope, appConfiguration, Access) {
  // The server merges this half into the boot payload when the page loaded with a session, and
  // froalaConfig only ever comes from that half. Read once at startup rather than on each call:
  // if the API ever stops sending the field, that costs one extra fetch, not one per navigation.
  var loaded = appConfiguration.froalaConfig !== undefined;
  var pending = null;

  return {
    load: function() {
      var token = Access.getAuthtoken();
      if (loaded || !token || !token.authtoken) {
        return $q.resolve();
      }
      if (!pending) {
        // No Authorization header: authInterceptor adds it, because a route resolve runs with
        // $location already on the secure route it is resolving.
        pending = $http.get(appConfiguration.apiUrl + '/v3/config/company')
          .then(function(response) {
            loaded = true;
            angular.extend(appConfiguration, response.data);
            $rootScope.$broadcast('companyConfiguration:loaded', response.data);
          })
          .catch(function(rejection) {
            // 403 only, unlike learners' useCompanyConfig which also takes 401: swallowing is
            // safe here solely because authInterceptor redirects on 403, and it redirects on
            // nothing else. A 401 added here would resolve the route with no config.
            if (rejection && rejection.status === 403) {
              return;
            }
            // Everything else must reject: FroalaOptions dereferences
            // `Application.froalaConfig.baseFontSize` when it is instantiated, so resolving
            // would open a route that throws.
            return $q.reject(rejection);
          })
          .finally(function() {
            pending = null;
          });
      }
      return pending;
    }
  };
}]);
